import { render, staticRenderFns } from "./dealeOrderReview.vue?vue&type=template&id=6be73dfc&scoped=true&"
import script from "./dealeOrderReview.vue?vue&type=script&lang=js&"
export * from "./dealeOrderReview.vue?vue&type=script&lang=js&"
import style0 from "./dealeOrderReview.vue?vue&type=style&index=0&id=6be73dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be73dfc",
  null
  
)

export default component.exports